export default "__VITE_ASSET__CGGQ5IM3__"